// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question .v-input--checkbox .v-label {\n  font-size: 10px;\n}\n.question .v-input--checkbox.select-multiple-choice {\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
